import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContextState } from './context.state';

const selectContextFeatureState = createFeatureSelector<ContextState>('context');
export const selectMultipleContextProperties = createSelector(
    selectContextFeatureState,
    state => state.multipleProperties
);

export const selectContextDetails = createSelector(
    selectContextFeatureState,
    state => state.details
);

export const selectContextCsm = createSelector(
    selectContextDetails,
    state => state.csm
);
